import React from 'react';
import { Route,Redirect } from 'react-router-dom'
import Home from '../home'
import Login from '../login'
import Messages from '../home/messages';
import About from '../about'
import '../../style.css'
import 'loaders.css/loaders.css'
const App = () => (
    <div>


        <main>
            <Route exact path="/" render={() => (
                <Redirect to="/login"/>
            )}/>
            <Route path="/home" component={Home} >
            </Route>
            <Route path="/messages/:id" component={Messages} >
            </Route>
            <Route exact path="/login" component={Login} />
            <Route exact path="/about-us" component={About} />
        </main>
    </div>
)
export default App;


// WEBPACK FOOTER //
// ./src/containers/app/index.js